import React, { FC } from 'react';

import ActionRow from './ActionRow';
import { ActionType } from 'src/actions/rules/actions';
import { StyledTypeDescription } from 'src/presentation/components/pages/rules/shared/StyledComponents';

type UnassignAgentActionProps = {
  onDelete: Function;
};

const UnassignAgentAction: FC<UnassignAgentActionProps> = ({ onDelete }) => {
  return (
    <ActionRow type={ActionType.UnassignAgent} onDelete={onDelete}>
      <StyledTypeDescription>Unassign from Agent</StyledTypeDescription>
    </ActionRow>
  );
};

export default UnassignAgentAction;
